import utils from "/node_modules/@ttcorestudio/viewer_data/library_files/Utils.js";
import plotMgrInstance from "/node_modules/@ttcorestudio/viewer_data/library_files/PlotMgr.js"
import * as d3 from "d3";
import {Plot} from "./Plot.js"

class ParallelCoordinatePlot extends Plot{
    constructor(initParams) { 
        super(initParams)
        this.type= "ParallelCoordinatePlot"
    }

    addParallelCoordinatePlot(newData, elementId, axisKeys, axisTypes, flipAxis = false, chartFormatting) {
        try {
            let scope = this;
            

            let dataObj = {};
            let dataArr = [];
            scope.formatting = { ...utils.defaultFormatting, ...(chartFormatting || {}) };

            scope.canvas.innerHTML = '';
            // Format the data for the plot type
            let response = utils.filterParallelCoordinate(newData, elementId, axisKeys, axisTypes);
            if (response.status == 'success') {
                dataObj = response.data;
            }

            dataArr = dataObj.data;
            dataArr.forEach(element => {
                scope.data[element.id] = element;
                scope.elements[element.id] = element.id;
            });

            scope.dataObj = dataObj
            scope.dataArr = dataArr

            // Get the first axis key from the data object
            let firstAxisKey = Object.keys(dataObj.axis)[0]
            
            //Find the longest categaory length from the first axis' dataset
            let longestLength = dataObj.axis[firstAxisKey].set.reduce((max, obj) => {
                return Math.max(max, obj.length)
            }, 0)  
            scope.paddingX = longestLength*5

            // set the dimensions and margins of the graph
            let width = scope.canvas.clientWidth - scope.margin.left - scope.margin.right - scope.paddingX
            let height = scope.canvas.clientHeight - scope.margin.top -25 - scope.margin.bottom

            let dimensions = "0 0 " + scope.canvas.offsetWidth + " " + scope.canvas.offsetHeight;

            //Determine the max number of ticks to use on categorical data
            let maxTicks = height/20

            // append the svg object to the body of the page
            scope.svg = d3.select(scope.canvas)
                .append('svg')
                .attr("viewBox", dimensions)
                .append('g')
                .attr('transform','translate(' + (scope.margin.left + scope.paddingX) + ',' + (scope.margin.top + 25) + ')');

            d3.select(scope.canvas)
                .style('pointer-events', 'none') // restricted mouse events
                .style('user-select', 'none') // stanard
                .style('-webkit-user-select', 'none') // safari
                .style('-ms-user-select', 'none'); // IE10 and IE11)

            scope.tooltip = d3.select(scope.canvas).append("div");
            utils.formatTooltipDefault(scope.tooltip, scope.defaultColor);

            // █▀▀ █▀▀ ▄▀▄ █   █▀▀ 
            // ▄██ █▄▄ █▀█ █▄▄ ██▄ 

            var y = {};
            var divisions = [];

            Object.keys(dataObj.axis).filter(function (key) {
                let axis = dataObj.axis[key];
                var scale = {}
                if (axis.type == 'value') {
                    scale = d3.scaleLinear()
                        .domain([axis.max, axis.min])
                        .range([0, height]);
                }
                else {
                    scale = d3.scalePoint()
                        .domain(axis.set)
                        .range([0, height]);
                }
                divisions.push(key);
                y[key] = scale;
            });
            scope.map = new Map(Array.from(Object.keys(y), key => [key, y[key]]));
            scope.divisions = divisions

            // Build the X scale -> it find the best position for each Y axis
            const x = d3.scalePoint()
                .domain(divisions)
                .range([0, width]);

            // ▀█▀ ▀█▀ █▀▀ █▄ ▄█ █▀▀ 
            // ▄█▄  █  ██▄ █ ▀ █ ▄██ 

            // The path function take a row of the csv as input, and return x and y coordinates of the line to draw for this raw.
            function path(d) {
                return d3.line()(divisions.map(function (p) { return [x(p), y[p](d[p])]; }));
            }

            // Draw the lines
            let items = scope.svg
                .selectAll("myPath")
                .data(dataArr)
                .join("path")
                .attr("class", function (d) { return "line " + d.id })
                .attr("d", path)
                .style("fill", "none")
                .style("shape-rendering", "geometricPrecision")
                .style("stroke-linejoin", "round")
                .style("stroke-width", scope.defaultWidth)
                .attr("data-id", function (d, i) {
                    scope.groups[d.id] = this;
                    return d.id;
                });

            // ▄▀▄ ▀▄▀ ▀█▀ █▀▀ 
            // █▀█ █ █ ▄█▄ ▄██ 

            // Draw the axis:
            let axisY = scope.svg.selectAll("axis")
                .data(divisions).enter()
                .append("g")
                .attr('name', 'axisY')
                .attr('color', scope.axisColor)
                .attr("transform", function (d) { return "translate(" + x(d) + ")"; })
                .each(function (d) { d3.select(this).call(d3.axisLeft().scale(y[d])); })

            axisY
                .append("text")
                .style("text-anchor", "middle")
                .attr("y", -10)
                .style("fill", scope.defaultColor)
                .style("font-weight", "bold")
                .text(function (d) { return d; });

            axisY
                .selectAll('path')
                .style("opacity", 0.3);

            axisY
                .selectAll('line')
                .style("opacity", 0.3);

            axisY
                .selectAll('text')
                .style("opacity", 1.0)
                .clone(true).lower()
                .attr("fill", "none")
                .attr("stroke-width", 4)
                .attr("stroke-linejoin", "round")
                .attr("stroke", "white");

            axisY
                .selectAll('text')
                .style('pointer-events', 'none') // restricted mouse events
                .style('user-select', 'none') // stanard
                .style('-webkit-user-select', 'none') // safari
                .style('-ms-user-select', 'none'); // IE10 and IE11)
            
            //Set max ticks show on a categorical axis
            axisY
                .each(function (d) { 
                    let axisType = scope.dataObj.axis[d].type; // Check if axis is 'value' or categorical
                    let axis = d3.select(this);
                    //if categorical data, limit the max number of ticks shown
                    if (axisType !== 'value') { 
                        let totalTicks = y[d].domain().length; 
                        let tickInterval = Math.ceil(totalTicks / maxTicks); 
                        let tickValues = y[d].domain().filter((_, i) => i % tickInterval === 0); 
            
                        axis.call(d3.axisLeft(y[d]).tickValues(tickValues)); 
                    } else {
                        axis.call(d3.axisLeft(y[d])); 
                    }
                });
            
            
            // █▄▄ █▀█ █ █ █▀▀ █▄█ 
            // █▄█ █▀▄ █▄█ ▄██ █ █ 
            const brush = this.createBrush(height)
            axisY.call(brush);

            // █▀▀ █▀█ █▀█ █▄ ▄█ ▄▀▄ ▀█▀ ▀█▀ ▀█▀ █▄ █ █▀▀ 
            // █▀  █▄█ █▀▄ █ ▀ █ █▀█  █   █  ▄█▄ █ ▀█ █▄█ 

            utils.formatStrokeItem(items, scope.tooltip, scope.defaultColor, scope.defaultOpacity);
            // utils.formatAxis(axisX, formatting.xAxis, this.axisColor);

            // utils.formatGrid(gridX, formatting.xGrid, this.gridColor, this.gridOpacity);

            // utils.formatGrid(gridY, formatting.yGrid, this.gridColor, this.gridOpacity);

            let returnValue = {
                'status': 'success',
                'message': 'ParallelCoordinate plot added'
            }
            scope.plotAdded = true
            return returnValue;
        }
        catch (err) {
            let returnValue = {
                'status': 'failed',
                'message': 'Failed to add ParallelCoordinate plot.' + err.message
            }
            return returnValue;
        }
    }
    createBrush(height) {
        const scope = this;
    
        const brushHeight = 25; 
        const brush = d3.brushY()
            .extent([
                [-(brushHeight / 2), 0],
                [brushHeight / 2, height]
            ])
            .on("start", function(event) {
                //scope.clearChart(event); 
            })
            .on("brush end", function(event) { 
                const key = d3.select(this).datum();
                scope.isBrushed(event, key);
            });
    
        return brush;
    }
    // Function that is triggered when brushing is started
    clearChart(event) {
        const scope = this
        scope.clearAllPickSelection()
        scope.onScrub("");
    }

    //triggered when brushing axis is ended
    isBrushed(event, key) {
        const scope = this;
        if (!scope.selections) {
            scope.selections = new Map();
        }
            
        const { selection, type } = event;
        
        // Only clear existing selections when ending with no selection (i.e., click without drag)
        if (!selection && type === "end") {
            scope.selections.delete(key);

            // If there are still active selections but nothing matches
            if (scope.selections.size > 0) {
                // Check if there are any matches across all selections
                const anyMatches = scope.checkAnyMatchesFilters();
                if (!anyMatches) {
                    // No matches - everything is filtered out
                    scope.onScrub([]); // Empty array means "everything filtered out"
                } else {
                    // Some matches remain with other filters
                    const selected = scope.getCurrentlySelectedItems();
                    scope.onScrub(selected.map(d => d.id));
                }
            } else {
                // No brushes anymore, clear the filter
                scope.onScrub("");
            }
            return;
        }

        // If this is not the end of a brush event or there is a selection, proceed as before
        if (!selection) return;

        let scale = scope.map.get(key);
        if (!scale) {
            return;
        }

        // Numerical axis
        if (typeof scale.invert === "function") {  
            // Map the selection using the axis's invert function
            scope.selections.set(key, selection.map(scale.invert));
        } // Categorical axis 
        else {  
            const range = scale.domain().map(scale);
            const i0 = d3.bisectLeft(range, selection[0]);
            const i1 = d3.bisectRight(range, selection[1]);
            scope.selections.set(key, scale.domain().slice(i0, i1));
        }

        // Filter the lines using the intersection of all brush selections
        const selected = [];
        scope.svg.selectAll("path.line").each(function (d) {
            const active = Array.from(scope.selections).every(([k, v]) => {
                return scope.dataObj.axis[k].type === 'value'
                    ? d[k] >= v[1] && d[k] <= v[0]
                    : v.includes(d[k]);
            });
            if (active && scope.selections.size > 0) {
                selected.push(d);
            }
        });

        const selectedIds = selected.map(a => a.id);
        // If we have brush selections but no matches, send empty array  "all filtered out"
        // send empty string to indicate "no filter"
        scope.onScrub(selectedIds.length > 0 ? selectedIds : []);
    }

    // Add this helper method to check if any items match all filters
    checkAnyMatchesFilters() {
        const scope = this;
        let anyMatches = false;
        
        // Check if any items match all filters
        scope.svg.selectAll("path.line").each(function (d) {
            const active = Array.from(scope.selections).every(([k, v]) => {
                return scope.dataObj.axis[k].type === 'value'
                    ? d[k] >= v[1] && d[k] <= v[0]
                    : v.includes(d[k]);
            });
            if (active) {
                anyMatches = true;
                return false; // Exit the each loop early
            }
        });
        
        return anyMatches;
    }

    getCurrentlySelectedItems() {
        const scope = this;
        const selected = [];
        
        scope.svg.selectAll("path.line").each(function(d) {
            const active = Array.from(scope.selections).every(([k, v]) => {
                return scope.dataObj.axis[k].type === 'value'
                    ? d[k] >= v[1] && d[k] <= v[0]
                    : v.includes(d[k]);
            });
            if (active && scope.selections.size > 0) {
                selected.push(d);
            }
        });
        
        return selected;
    }

    resizeChart(){
        
        let scope = this;        
    
        // Set the dimensions and margins of the graph
        let width = scope.canvas.clientWidth - scope.margin.left - scope.margin.right - scope.paddingX
        let height = scope.canvas.clientHeight - scope.margin.top - 25 - scope.margin.bottom;

        let maxTicks = height/20

        // Update SVG dimensions
        d3.select(scope.canvas).select("svg")
            .attr("viewBox", `0 0 ${scope.canvas.offsetWidth+scope.paddingX} ${scope.canvas.offsetHeight}`)
        
        //Get X and Y Values
        var y = {};
        var divisions = [];

        Object.keys(scope.dataObj.axis).filter(function (key) {
            let axis = scope.dataObj.axis[key];
            var scale = {}
            if (axis.type == 'value') {
                scale = d3.scaleLinear()
                    .domain([axis.max, axis.min])
                    .range([0, height]);
            }
            else {
                scale = d3.scalePoint()
                    .domain(axis.set)
                    .range([0, height]);
            }
            divisions.push(key);
            y[key] = scale;
        }); 

        //Update the mapping with new scales so brushing gets remapped
        scope.map = new Map(Object.entries(y))

        const x = d3.scalePoint()
            .domain(divisions)
            .range([0, width]);
    
        // Path function
        function path(d) {
            return d3.line()(divisions.map(function (p) { return [x(p), y[p](d[p])]; }));
        }
    
        // Redraw the lines
        let items = scope.svg.selectAll("path.line")
            .attr("d", path)
    
        // Redraw the axis
        scope.svg.selectAll('g[name="axisY"]')
        .attr("transform", function (d) { return "translate(" + x(d) + ")"; })
        .each(function (d) {
            let axisType = scope.dataObj.axis[d].type;
            let axis = d3.select(this);
            //Set max ticks shown for categorical axis
            if (axisType != 'value') { 
                let totalTicks = y[d].domain().length;
                let tickInterval = Math.ceil(totalTicks / maxTicks); 
                let tickValues = y[d].domain().filter((_, i) => i % tickInterval === 0);
                axis.call(d3.axisLeft(y[d]).tickValues(tickValues));
            }
            else {
                axis.call(d3.axisLeft(y[d]).ticks(scope.maxTicks));
            }
        });
        
        // █▄▄ █▀█ █ █ █▀▀ █▄█ 
        // █▄█ █▀▄ █▄█ ▄██ █ █ 
        const newBrush = scope.createBrush(height);
        scope.svg.selectAll('g[name="axisY"]').call(newBrush);
    }


    //  ████  ███  █      ███  ████     ████  █   █ 
    // █     █   █ █     █   █ █   █    █   █  █ █  
    // █     █   █ █     █   █ ████     ████    █   
    // █     █   █ █     █   █ █   █    █   █   █   
    //  ████  ███  █████  ███  █   █    ████    █   


    colorElements(ids, colors) {
        let scope = this;

        Object.keys(scope.groups).forEach(key => {
            let index = ids.indexOf(key);
            let highlightedElement = d3.select(scope.groups[key]);
            scope.applyColor(highlightedElement, colors[index])
        });
    }


    // █████ █████ █     █████  ████ █████ 
    // █     █     █     █     █       █   
    // █████ ████  █     ████  █       █   
    //     █ █     █     █     █       █   
    // █████ █████ █████ █████  ████   █   


    // SELECTION event
    getSelectedElementsCondition(group, selectedElement, callBack, ids){
        let scope = this;
        if (scope.data[selectedElement.attr('data-id')]) {
            scope.selectedElements.push(scope.data[selectedElement.attr('data-id')].id)

            //scope.applySelectionColor(selectedElement);

            callBack([...new Set(scope.selectedElements)]);
        }
        else {
            callBack('');
            plotMgrInstance.deSelectElementsInAllPlots();
        }
    }

    selectElements(elementIDs) {
        let scope = this;
        if (scope.highlightElementFlagCheck) {
            if (scope.svg != undefined) {
                if (elementIDs && elementIDs.length > 0) {
                    // Reset any previously applied selection colors
                    Object.keys(scope.groups).forEach(key => {
                        d3.select(scope.groups[key]).classed("selected", false);
                    });
                    
                    // Apply selection colors only to the specified elements
                    let elems = {};
                    elementIDs.forEach(id => {
                        let key = scope.elements[id];
                        if (key) {
                            if (!elems[key]) elems[key] = [];
                            elems[key].push(id);
                        }
                    });
                    
                    Object.keys(elems).forEach(key => {
                        var element = d3.select(scope.groups[key]);
                        element.raise();
                        if (scope.data[key]) {
                            scope.applySelectionColor(element);
                            element.classed("selected", true);
                        }
                    });
                } else {
                    // Clear all selections if empty array is passed
                    scope.svg.selectAll("path.line.selected").each(function() {
                        const element = d3.select(this);
                        element.classed("selected", false);
                        if (element.attr('data-isClr') !== 'true') {
                            element.style("stroke", scope.defaultColor);
                        }
                    });
                }
            }
        }
    }


    // █   █ █████  ████ █   █ █     █████  ████ █   █ █████ 
    // █   █   █   █     █   █ █       █   █     █   █   █   
    // █████   █   █  ██ █████ █       █   █  ██ █████   █   
    // █   █   █   █   █ █   █ █       █   █   █ █   █   █   
    // █   █ █████  ███  █   █ █████ █████  ███  █   █   █   


    // Highlight event
    highlightGroup(highlightedElement, event, callBack,){
        let scope = this;
    
        if (highlightedElement.attr('data-id') != undefined) {
            scope.applyHighlightColor(highlightedElement);
            scope.applyToolTip(event, highlightedElement.attr('data-id'));
            callBack([scope.data[highlightedElement.attr("data-id")].id]);
        }
        else {
            callBack("");
            plotMgrInstance.deHighlightElementsInAllPlots();
        }
      }

    //Highlight Element  
    elementGroup(elems) {
        let scope = this;

        Object.keys(elems).forEach(key => {
            var element = d3.select(scope.groups[key]);
            if (scope.data[key]) {
                scope.applyHighlightColor(element);
            }
        });
    }
    
    // apply tool tip
    applyToolTip(event, id) {
        let scope = this;

        utils.formatTooltipMove(d3.pointer(event), scope.tooltip);

        var content = '';
        Object.keys(scope.data[id]).forEach(key => {
            if (key != 'id') content += "<strong>" + key + "</strong> | " + utils.setDigits(scope.data[id][key], scope.digits) + "<br/>";
        });

        scope.tooltip.html(content)
    }

    raiseElements(element) {
        // element.raise();
        // this.svg.selectAll("myAxis").raise();
    }

    // Update line visibility based on filtered/selected status
    updateLineVisibility(filteredInIds,filteredOutIds, effect) {
        
        const validEffects = ['fade', 'grey', 'remove', 'none'];
        if (!validEffects.includes(effect)) {
            //console.warn(`Invalid effect "${effect}". Defaulting to "fade".`);
            effect = 'fade';
        }
        const scope = this;

        if (scope.svg == undefined) return;

        // First reset all lines to default state
        scope.svg.selectAll("path.line")
            .style("opacity", scope.defaultOpacity)
            .style("stroke-width", scope.defaultWidth)
            .style("stroke", function() {
                return d3.select(this).attr('data-isClr') === 'true' ? 
                    d3.select(this).attr('data-color') : scope.defaultColor;
            });

        if (effect === 'none') {
            //make all default
            scope.svg.selectAll("path.line")
                    .style("opacity", scope.defaultOpacity)
                    .style("stroke-width", scope.defaultWidth);
        }
        else if (effect === 'fade') {
            //make filteredIds thin transparent and unfilteredIds bold
            filteredOutIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("opacity", .15)
                        .style("stroke-width", scope.defaultWidth * 0.2);
                }
            });

            filteredInIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("opacity", 1)
                        .style("stroke-width", scope.defaultWidth * 1.5);
                }
            });
        }
        else if (effect === 'grey') {
            //make filteredIds grey and unfilteredIds bold
            filteredOutIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("stroke-width", scope.defaultWidth * 0.2)
                        .style("stroke", "#D3D3D3")
                        .style("opacity", scope.defaultOpacity);
                }
            });

            filteredInIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("stroke-width", scope.defaultWidth * 1.5)
                        .style("opacity", 1);
                }
            });
        }
        else if (effect === 'remove') {
            //make filteredIds invisible and unfilteredIds default
            filteredOutIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("opacity", 0)
                        .style("stroke-width", scope.defaultWidth * 0.2);
                }
            });
            filteredInIds.forEach(id => {
                const element = d3.select(scope.groups[id]);
                if (element.node()) {
                    element.raise()
                        .style("opacity", 1)
                        .style("stroke-width", scope.defaultWidth);
                }
            });
        }

        //after applying effect, raise the brush box to the top
        scope.svg.selectAll('g[name="axisY"]').raise();
    }
}
export { ParallelCoordinatePlot }